var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Pagination',_vm._g(_vm._b({staticClass:"ts-pagination",attrs:{"layout":"prev, pager, next"}},'Pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }